// src/lib/usePlanPricing.js
import React from "react";
import { usePlans } from "./plansClient";

/** Mevcut kart yapısını ELLEMEDEN fiyat/currency okuma helper'ı */
export function usePlanPricing() {
  const { data, plans, loading, error } = usePlans();

  const byCode = React.useMemo(() => {
    const map = {};
    for (const p of plans) map[p.code || p.id] = p;
    return map;
  }, [plans]);

  const currency = (code) => byCode[code]?.currency || "USD";
  
  const symbol = (code) => {
    const cur = currency(code);
    return cur === "TRY" ? "₺" : cur === "EUR" ? "€" : cur === "GBP" ? "£" : "$";
  };

  const price = (code, period = "month") => {
    const p = byCode[code];
    if (!p) return 0;
    const monthly = Number(p.price || 0);
    if (period === "year") {
      return p.yearPrice != null ? Number(p.yearPrice) : monthly * 12;
    }
    return monthly;
  };

  const planDetails = (code) => byCode[code] || null;

  return {
    loading,
    error,
    version: data?.version || 0, // istersen key olarak kullanırsın
    price,
    currency,
    symbol,
    planDetails,
    plans, // tüm planlar
  };
}
